import script from "./ObjectiveMoveConflictItems.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectiveMoveConflictItems.vue?vue&type=script&setup=true&lang=js"

import "./ObjectiveMoveConflictItems.vue?vue&type=style&index=0&id=0737c223&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0737c223"]])

export default __exports__